export default {
  "text-about": ""
};



// WEBPACK FOOTER //
// ./src/lang/about/ja.js